// @flow

import React, { PureComponent } from 'react';
import { Box, Text, Icon } from 'gestalt';

type Props = {|
  bold?: boolean,
  icon?:
    | 'add'
    | 'cancel'
    | 'clear'
    | 'globe'
    | 'person'
    | 'pinterest'
    | 'question-mark'
    | 'remove'
    | 'report'
    | 'send'
    | 'share'
    | 'unfollow'
    | 'download',
  text?: string,
  description?: string,
  compact?: boolean,
|};

const unfollowSvg =
  'M8.134 8.116a1.25 1.25 0 0 0-1.768 0L4.25 10.232 2.134 8.116A1.25 1.25 0 0 0 .366 9.884L2.483 12 .366 14.116a1.25 1.25 0 0 0 1.768 1.768l2.116-2.117 2.116 2.117a1.248 1.248 0 0 0 1.768 0 1.25 1.25 0 0 0 0-1.768L6.018 12l2.116-2.116a1.25 1.25 0 0 0 0-1.768M24 8v8a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 11 16V8a2.5 2.5 0 0 1 2.5-2.5h8A2.5 2.5 0 0 1 24 8';

const unfollowPath = { __path: unfollowSvg };

type State = {|
  hovered: boolean,
|};

export default class DropdownOption extends PureComponent<Props, State> {
  static defaultProps = {
    bold: true,
  };

  state: State = {
    hovered: false,
  };

  handleMouseEnter = (event: SyntheticMouseEvent<>) => this.setState({ hovered: true });
  handleMouseLeave = (event: SyntheticMouseEvent<>) => this.setState({ hovered: false });

  render() {
    const { bold, icon, text, description, compact } = this.props;
    const title = Array.isArray(text) ? text.join('') : text;
    return (
      <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <Box
          alignItems="start"
          color={this.state.hovered ? 'lightGray' : 'transparent'}
          display="flex"
          direction="row"
          overflow="hidden"
          paddingX={4}
          paddingY={2}
          marginStart={-1}
          marginEnd={-1}
          title={title}
        >
          {!compact &&
            icon && (
              <Box flex="none" padding={1}>
                {icon === 'unfollow' ? (
                  <Icon
                    accessibilityLabel=""
                    color="darkGray"
                    dangerouslySetSvgPath={unfollowPath}
                    size={16}
                  />
                ) : (
                  <Icon accessibilityLabel="" color="darkGray" icon={icon} size={16} />
                )}
              </Box>
            )}
          <Box
            flex="grow"
            display="flex"
            direction={compact ? 'row' : 'column'}
            padding={1}
            width="100%"
            alignItems={compact ? 'center' : 'start'}
          >
            <Text color="darkGray" size={compact ? 'sm' : 'md'} weight={bold ? 'bold' : 'normal'}>
              {text}
            </Text>
            <Box display="flex" alignItems="center">
              {!compact &&
                description && (
                  <Box marginTop={1}>
                    <Text color="darkGray" overflow="normal">
                      {description}
                    </Text>
                  </Box>
                )}
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
